// Copyright 2017-2026 @polkadot/apps-config authors & contributors
// SPDX-License-Identifier: Apache-2.0

import type { HexString } from '@polkadot/util/types';

const G1_GENESIS_HASH_KEY = 'g1-genesis-hash';

export function validateGenesisHash (raw: string): HexString | null {
  const trimmed = raw.trim();

  if (/^0x[0-9a-fA-F]{64}$/.test(trimmed)) {
    return trimmed as HexString;
  }

  return null;
}

export function getCachedG1GenesisHash (): HexString | null {
  try {
    const stored = localStorage.getItem(G1_GENESIS_HASH_KEY);

    return stored ? validateGenesisHash(stored) : null;
  } catch {
    return null;
  }
}

export function setCachedG1GenesisHash (hash: HexString): void {
  try {
    localStorage.setItem(G1_GENESIS_HASH_KEY, hash);
  } catch {
    console.warn('[g1Genesis] Failed to write to localStorage');
  }
}

export function isG1Available (): boolean {
  return getCachedG1GenesisHash() !== null;
}

export function getDefaultNetwork (): 'g1' | 'gtest' {
  return isG1Available() ? 'g1' : 'gtest';
}
